export default function TobaccoUsage(e) {
  const tobaccoValue = e;
  let tobaccoStatus;

  switch(tobaccoValue) {
    case "Never":
      tobaccoStatus = "false"
      break;
    case "Never used":
      tobaccoStatus = "false"
      break;
    case "Currently use":
      tobaccoStatus = "true"
      break;
    case "Within the last year":
      tobaccoStatus = "true"
      break;
    case "Within the last 13-36 months":
      tobaccoStatus = "true"
      break;
    case "Within the last 1 to 3 years":
      tobaccoStatus = "true"
      break;
    case "Within the last 3 to 5 years":
      tobaccoStatus = "true"
      break;
    case "Over 36 months":
      tobaccoStatus = "false"
      break;
    case "Over 5 years ago":
      tobaccoStatus = "false"
      break;
    case "false":
      tobaccoStatus = "false"
      break;
    case "true":
      tobaccoStatus = "true"
      break;
    case "yes":
      tobaccoStatus = "yes"
      break;
    case "no":
      tobaccoStatus = "no"
      break;
    default:
      break;
  }
  return tobaccoStatus;
}


// WEBPACK FOOTER //
// ./src/components/Quoters/Common/Helpers/TobaccoUsage.js